import { aceptaPublicidad } from "../consentimiento/consentimiento";

// Pixel de Meta del organizador de cada evento. El script se carga una sola
// vez, recién cuando hay un pixel y el visitante aceptó cookies de publicidad.
// Se usa trackSingle para que dos eventos con pixels distintos no se mezclen.

const SCRIPT = "https://connect.facebook.net/en_US/fbevents.js";
const iniciados = new Set();
const porEvento = {};

const instalarFbq = () => {
  if (window.fbq) return;
  /* eslint-disable */
  const fbq = function () {
    fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
  };
  /* eslint-enable */
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];
  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;
  const script = document.createElement("script");
  script.async = true;
  script.src = SCRIPT;
  document.head.appendChild(script);
};

// configurarEvento guarda el pixel y la moneda que devolvió el backend
export const configurarEvento = (idevento, { meta_pixel_id: pixel, moneda } = {}) => {
  porEvento[String(idevento)] = { pixel: pixel || "", moneda: moneda || "ARS" };
};

export const configDe = (idevento) => porEvento[String(idevento)] || null;

const preparar = (pixel) => {
  if (!pixel || !aceptaPublicidad()) return false;
  instalarFbq();
  if (!iniciados.has(pixel)) {
    window.fbq("init", pixel);
    iniciados.add(pixel);
  }
  return true;
};

// rastrear manda un evento al pixel; no hace nada sin pixel o sin consentimiento
export const rastrear = (pixel, nombre, datos = {}, opciones) => {
  if (!preparar(pixel)) return false;
  window.fbq("trackSingle", pixel, nombre, datos, opciones);
  return true;
};

export const rastrearEvento = (idevento, nombre, datos = {}, opciones) => {
  const config = configDe(idevento);
  return config ? rastrear(config.pixel, nombre, datos, opciones) : false;
};

// cookiesDeMeta: las cookies que deja el pixel (_fbp y _fbc). La Conversions
// API las usa para juntar la compra con quien vio el anuncio.
export const cookiesDeMeta = (cookies = typeof document !== "undefined" ? document.cookie : "") => {
  const valor = (nombre) => cookies.split("; ").find((c) => c.startsWith(`${nombre}=`))?.slice(nombre.length + 1) || "";
  const datos = {};
  const fbp = valor("_fbp");
  const fbc = valor("_fbc");
  if (fbp) datos.fbp = decodeURIComponent(fbp);
  if (fbc) datos.fbc = decodeURIComponent(fbc);
  return datos;
};

const claveInformada = (idcompra) => `meta_purchase_${idcompra}`;

// purchaseYaInformado evita mandar dos veces la compra (recargas de la página)
export const purchaseYaInformado = (idcompra, storage = window.localStorage) => {
  try {
    return storage.getItem(claveInformada(idcompra)) === "1";
  } catch {
    return false;
  }
};

export const marcarPurchase = (idcompra, storage = window.localStorage) => {
  try {
    storage.setItem(claveInformada(idcompra), "1");
  } catch {
    // sin almacenamiento puede repetirse; Meta deduplica por eventID
  }
};

// datosPurchase arma el evento Purchase de una compra aprobada; null si no corresponde
export const datosPurchase = (compra) => {
  if (!compra || !compra.aprobada || !compra.meta_pixel_id || !(compra.valor > 0)) return null;
  return {
    pixel: compra.meta_pixel_id,
    datos: {
      value: Math.round(compra.valor * 100) / 100,
      currency: compra.moneda || "ARS",
      content_ids: [String(compra.idevento)],
      content_type: "product",
      num_items: compra.entradas || undefined,
    },
    opciones: { eventID: `compra_${compra.idcompra}` },
  };
};
